import React, { createContext, useState } from 'react'

import { IGetAllItemsResponse, IGetAllSubItensResponse } from 'services/GST/CadastroItensSubitensSeguranca'
import { useToggle } from 'hooks'

interface IUseSecurityItemsAndSubItens {
  selectedItemForEdit: IGetAllItemsResponse | IGetAllSubItensResponse
  setSelectedItemForEdit: React.Dispatch<React.SetStateAction<IGetAllItemsResponse | IGetAllSubItensResponse>>
  showEditItemModal: boolean
  toggleEditItemModal: () => void
  selectedItem: IGetAllItemsResponse
  setSelectedItem: React.Dispatch<React.SetStateAction<IGetAllItemsResponse>>
}

export const SecurityItemsAndSubItensContext = createContext<IUseSecurityItemsAndSubItens>(null)

export const SecurityItemsAndSubItensProvider: React.FC = ({ children }) => {
  const [selectedItemForEdit, setSelectedItemForEdit] = useState<IGetAllItemsResponse | IGetAllSubItensResponse>()
  const [selectedItem, setSelectedItem] = useState<IGetAllItemsResponse>()
  const [showEditItemModal, toggleEditItemModal] = useToggle()

  return (
    <SecurityItemsAndSubItensContext.Provider value={{
      selectedItemForEdit,
      setSelectedItemForEdit,
      showEditItemModal,
      toggleEditItemModal,
      selectedItem,
      setSelectedItem
    }}>
      {children}
    </SecurityItemsAndSubItensContext.Provider>
  )
}
